import React from "react";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import Input from "../Formsy/Input";
import TrashIcon from "react-icons/lib/fa/trash-o";

import theme from "../../themes/green";
import InspectorSection from "./InspectorSection";
import { FileInput } from "../Formsy";
import { Button } from "../../components/UIKit";

class SceneEditor extends React.Component {
  constructor() {
    super();
    this.state = {
      canSubmit: false
    };

    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  onRemove() {
    this.props.onRemove(this.props.element);
  }

  onReset(fields) {
    const model = this.form.getModel();
    this.form.reset({ ...model, ...fields });
  }

  onValidSubmit(data) {
    this.props.onValidSubmit(data, this.props.path);
  }

  disableButton() {
    this.setState({ canSubmit: false });
  }

  enableButton() {
    this.setState({ canSubmit: true });
  }

  render() {
    const { name = "", panorama } = this.props.element || {};
    const { downloadURL = "" } = panorama || {};
    return (
      <Formsy
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        onValidSubmit={this.onValidSubmit}
        style={{ width: "100%" }}
        ref={component => {
          this.form = component;
        }}
      >
        <InspectorSection hideHeader>
          <Input
            name="name"
            placeholder="Scene name..."
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: "0" }
            }}
            /* forceBackground */
            value={name}
          />
        </InspectorSection>
        <InspectorSection onReset={this.onReset} title={"Scene panorama"}>
          <FileInput
            name="panorama"
            style={{ color: "black" }}
            imageUrl={downloadURL}
            multiple={false}
          />
        </InspectorSection>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden"
          }}
        >
          <Button
            type="submit"
            style={{
              background: "rgb(45,228,136)",
              marginLeft: "0px"
            }}
            disabled={!this.state.canSubmit}
          >
            <span style={{ color: "rgb(72,97,102)" }}>Save</span>
          </Button>
          <Button
            type="button"
            style={{
              background: "rgb(45,228,136)",
              marginLeft: "0px"
            }}
          >
            <TrashIcon
              style={{ color: "#476166", cursor: "pointer" }}
              onClick={this.onRemove}
            />
          </Button>
        </div>
      </Formsy>
    );
  }
}

SceneEditor.propTypes = {
  path: PropTypes.string.isRequired,
  element: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  onValidSubmit: PropTypes.func,
  project: PropTypes.shape().isRequired
};

SceneEditor.defaultProps = {
  onValidSubmit: () => {}
};

export default SceneEditor;



// WEBPACK FOOTER //
// ./src/components/Inspector/sceneEditor.js